(() => {
	angular.module('main').controller('LoginController', LoginController);

	LoginController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$http',
		'accountService',
		'accountDataService',
		'messageService',
		'authTokensService'
	];

	function LoginController(
		$scope,
		$rootScope,
		$location,
		$http,
		accountService,
		accountDataService,
		messageService,
		authTokensService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$rootScope.signInPage = true;
			$scope.navbarSignIn = true;
			$scope.navbarSignUp = false;
			$scope.stayLogin = false;
			$rootScope.navbarSignUp = $scope.navbarSignUp;
			$rootScope.navbarSignIn = $scope.navbarSignIn;
			$scope.isSignInwSpinnningWheelActive = false;
		});

		$scope.login = function(email, password, stayLogin) {
			$scope.email = email;
			$scope.isSignInwSpinnningWheelActive = true;
			$scope.button_disable = true;
			delete $rootScope.error;
			$rootScope.showTrialModal = true;
			$rootScope.trialModalTitles = [
				'Happiness is an unlimited Studio Ninja account.',
				'One small act can make a huge difference.',
				"Let's karate-chop across the world together.",
				'This is only the beginning. Grow with us!',
				'Think big. Dream bigger. Go unlimited.',
				"The world is your oyster. We'll make you the pearl!"
			];

			accountService
				.authenticateWeb(email, password, stayLogin)
				.finally(() => {
					$scope.button_disable = false;
					$scope.isSignInwSpinnningWheelActive = false;
				})
				.subscribe(
					data => authenticationSuccessCallback(data),
					error => authenticationErrorCallback(error)
				);
			localStorage.setItem('isStayLogin', stayLogin);
		};

		function authenticationErrorCallback(error) {
			const { errorMessage } = error;
			$rootScope.authenticated = false;
			if (errorMessage === 'Registration confirmation required') {
				toastr.remove();
				$('#confirm').modal('show');
			}
		}

		$scope.resendConfirm = () => {
			$('#confirm').modal('hide');
			accountDataService.resendConfirmEmail($scope.email).subscribe(() => {
				messageService.showToaster('s_0', 'general', 'Check your mail');
			});
		};

		$scope.publicNavbarClick = () => {
			$scope.navbarSignUp = !$scope.navbarSignUp;
			if ($location.path() === '/subscription') {
				accountService.logoutWeb();
			}
		};

		$scope.acceptTermsOfUse = function() {
			$scope.button_disable = true;
			$scope.isSignInwSpinnningWheelActive = true;

			accountDataService
				.acceptTermsOfUse()
				.finally(() => ($scope.button_disable = true))
				.subscribe(
					() => {
						$('#termsUpdatedModal').modal('hide');
						getUser();
					},
					error => messageService.showDefaultErrorMessage(error)
				);
		};

		function getUser() {
			accountService.getUserWeb().subscribe(user => {
				if (!user) {
					console.log('No authentication data');
					return;
				}

				$rootScope.hasSubscriptionBefore = user.hasSubscriptionBefore;
				if (user.termsOfUseAgree !== true && !user.admin) {
					$('#termsUpdatedModal').modal('show');
				} else if (user.expired) {
					$location.path('/subscription');
				} else if (user.enabled) {
					$rootScope.removeBg = 'blah';
					toastr.clear();
					$location.path('/');
				} else {
					$location.path('/login');
					messageService.showToaster('e_2', 'general', user.message);
				}
			});
		}

		function authenticationSuccessCallback(data) {
			const { access_token, refresh_token } = data;
			authTokensService.setAuthToken(access_token);
			authTokensService.setRefreshToken(refresh_token);
			getUser();
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/login/loginController.js